import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { PlannedAdmission, PlannedAdmissionDetails } from '@shared/services/admissions/getLists/types';

import { initialState } from './initialState';

const admissionSlice = createSlice({
  initialState,
  name: 'Admission',
  reducers: {
    setSelectedAdmission: (state, action: PayloadAction<PlannedAdmission>) => {
      state.selectedAdmission = action.payload;
    },
    setEbsNo: (state, action: PayloadAction<null | string>) => {
      state.ebsNo = action.payload;
    },
    setHasDisplayedFinancialConsents: (state, action: PayloadAction<boolean>) => {
      state.hasDisplayedFinancialConsents = action.payload;
    },
    setAdmissionDetails: (state, action: PayloadAction<null | PlannedAdmissionDetails>) => {
      state.admissionDetails = action.payload;
    },
    setPaymentType: (state, action: PayloadAction<null | string>) => {
      state.paymentType = action.payload;
    },
    setPaymentCallback: (state, action: PayloadAction<null | string>) => {
      state.paymentCallback = action.payload;
    },
    setFilters: (state, action: PayloadAction<any[]>) => {
      state.filters = action.payload;
    },
  },
});

export const { actions: admissionAction } = admissionSlice;

export default admissionSlice.reducer;
